<template>
  <ShowControl  @revert="revertClick"  :title="title" ref="showControl">
    <div  style="margin-top: 3%;">
      <div class="div">参展商:{{String(tableData.exhibitor).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}家</div>
      <div class="div">参展观众:{{String(tableData.audience).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}位</div>
      <div class="div">专家:{{String(tableData.expert).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}位</div>
      <div class="div">签到:{{String(tableData.signIn).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}条</div>
      <div class="div">住宿安排:{{String(tableData.stay).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}位</div>
      <div v-if="restaurant!=null"
          class="div">餐饮安排:{{tableData.restaurant}}</div>
      <div v-if="restaurant==null"
          class="div">餐饮安排:暂未安排餐饮</div>
    </div>
  </ShowControl>
</template>

<script>
import { mapState } from "vuex";
import ShowControl from "../../UserControl/ShowControl.vue"
export default {
  components: {
    ShowControl
  },
  data () {
    return {
      tableData: {},
      flowID: localStorage.getItem("flowID"),
      title: '过程数据分析'
    }
  },
  computed: {
    ...mapState({
      Round: (state) => state.user.round,
      ChatShow:(state) => state.user.chatShows,
    }),
  },
  created () {
    this.GetProcessList();
  },
  mounted(){
    this.$refs.showControl.receiveValue(true);
  },
  methods: {
    revertClick(){
      this.$router.push("/DataAnalysis")
    },
    GetProcessList () {
      this.$http.get('Process/GetProcessList?round=' + this.Round).then((res) => {
        if (res.success) {
          this.tableData = res.dynamicObj
          this.$store.commit("chatShow",{ isOperate : !this.ChatShow, chatValue: this.Global.OperateType.过程数据分析查看 });  
          // if (this.flowID == this.Global.FlowList.反馈) {
          //   this.$http.get(`User/AnalysisScore?round=${this.Round}`).then((res) => {
          //     if (res.success) {
          //     }
          //   })
          // }
        } else {
          return this.$message.error(res.message)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.div {
  font-size: 30px;
  margin-top: 2px;
}
</style>